import { useContext, useEffect, useState } from "react";
import Pagination from "../global/Pagination";
import InvoicesTable from "./InvoicesTable";
import { InvoicesContext } from "../../context/InvoicesContext";
import PanelTitle from "../global/PanelTitle";

const PAGE_SIZE = 20;

const CustomerInvoices = ({ customer_id }) => {
  const [page, setPage] = useState(1);
  const { total, invoices, getInvoices } = useContext(InvoicesContext);

  useEffect(() => {
    getInvoices({ customer_id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, customer_id]);

  return (
    <div className="card p-3 pb-1 no-scale my-3">
      <PanelTitle title="Cargos" hideButton />
      {Array.isArray(invoices) ? (
        <InvoicesTable invoices={invoices} />
      ) : (
        <div className="spinner-border mb-3" />
      )}
      {total > PAGE_SIZE && (
        <Pagination
          totalItems={total}
          currentPage={page}
          itemsPerPage={PAGE_SIZE}
          onPageChange={setPage}
        />
      )}
    </div>
  );
};

export default CustomerInvoices;
